module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-21-a6c87117376d50d914274ebbf12211d7.jpg";